import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=30f6ba3b&scoped=true"
import script from "./MenuTable.vue?vue&type=script&lang=js"
export * from "./MenuTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6ba3b",
  null
  
)

export default component.exports